import { defineMessages, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'navigationHotkeys.StoreSetupSettingsPage',
    defaultMessage: 'Store Setup Settings',
    id: 'Qog3hf',
  },
});

export const hotkey = ['g', 'a', 's'];
export const barcodeContent = '+GNZD2R92V9H7=';

const GotoStoreSetupSettingsPage = ({ children }) => {
  const intl = useIntl();
  const history = useHistory();
  const handler = useCallback(() => history.push('/settings/stores'), [history]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['gas'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'navigation',
      isGlobal: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

GotoStoreSetupSettingsPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GotoStoreSetupSettingsPage;
